import { INSERT_PLUGIN_BUTTONS, TOOLBARS, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { Node_Type } from 'ricos-types';
import { verticalEmbedModals } from './constants.js';
import InsertModal from './modals/InsertModal.js';
import Event from './icons/Event.js';
import Booking from './icons/Booking.js';
import Product from './icons/Product.js';
import 'ricos-schema';
import 'react';
import 'ricos-context';
import './toolbar/VerticalEmbedInsertModal.js';
import 'prop-types';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-ui-components';
import './ItemsList-bf69fbd1.js';
import './style-inject.es-746bb8ed.js';
import 'classnames';
import './toolbar/itemsList/Item.js';
import 'wix-rich-content-common/libs/imageUtils';
import './dataHooks.js';
import './convertDuration.js';
import 'lodash';
import './types.js';
import 'wix-rich-content-common';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getAddButtons = (config, services) => {
  const { exposeEmbedButtons = [] } = config || {};
  const buttonsMap = {
    event: {
      id: `${Node_Type.APP_EMBED}.event`,
      label: INSERT_PLUGIN_BUTTONS.EVENTS,
      dataHook: INSERT_PLUGIN_BUTTONS.EVENTS,
      icon: Event,
      tooltip: "EventsPlugin_InsertButton_Tooltip",
      toolbars: [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      command: (editorCommands) => true,
      modal: {
        id: verticalEmbedModals.insertEvent,
        Component: decorateComponentWithProps(InsertModal, {
          verticalsApi: config == null ? void 0 : config.verticalsApi,
          componentData: { type: "EVENT" },
          modalId: verticalEmbedModals.insertEvent
        })
      },
      menuConfig: {
        tags: "Events_plugin_search_tags",
        group: "embed_wix"
      }
    },
    booking: {
      id: `${Node_Type.APP_EMBED}.booking`,
      label: INSERT_PLUGIN_BUTTONS.BOOKINGS,
      dataHook: INSERT_PLUGIN_BUTTONS.BOOKINGS,
      icon: Booking,
      tooltip: "BookingsPlugin_InsertButton_Tooltip",
      toolbars: [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      command: (editorCommands) => true,
      modal: {
        id: verticalEmbedModals.insertBooking,
        Component: decorateComponentWithProps(InsertModal, __spreadProps(__spreadValues({}, config), {
          componentData: { type: "BOOKING" },
          modalId: verticalEmbedModals.insertBooking
        }))
      },
      menuConfig: {
        tags: "Bookings_plugin_search_tags",
        group: "embed_wix"
      }
    },
    product: {
      id: `${Node_Type.APP_EMBED}.product`,
      label: INSERT_PLUGIN_BUTTONS.STORES,
      dataHook: INSERT_PLUGIN_BUTTONS.STORES,
      icon: Product,
      tooltip: "StoresPlugin_InsertButton_Tooltip",
      toolbars: [TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE],
      command: (editorCommands) => true,
      modal: {
        id: verticalEmbedModals.insertProduct,
        Component: decorateComponentWithProps(InsertModal, __spreadProps(__spreadValues({}, config), {
          componentData: { type: "PRODUCT" },
          modalId: verticalEmbedModals.insertProduct
        }))
      },
      menuConfig: {
        tags: "Stores_plugin_search_tags",
        group: "embed_wix"
      }
    }
  };
  return exposeEmbedButtons.map((buttonType) => buttonsMap[buttonType]);
};

export { getAddButtons };
//# sourceMappingURL=getAddButtons.js.map
